import React from 'react';
import Icon from '../../../components/AppIcon';

const BandStats = ({ bands }) => {
  const totalBands = bands?.length;
  const activeBands = bands?.filter(band => band?.status === 'active')?.length;
  const draftBands = bands?.filter(band => band?.status === 'draft')?.length;
  const totalEmployees = bands?.reduce((sum, band) => sum + band?.employeeCount, 0);
  
  const averageSalary = bands?.length > 0 
    ? bands?.reduce((sum, band) => sum + ((band?.minSalary + band?.maxSalary) / 2), 0) / bands?.length
    : 0;

  const complianceIssues = bands?.filter(band => 
    band?.complianceFlags && band?.complianceFlags?.length > 0
  )?.length;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-EU', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const stats = [
    {
      label: 'Total Pay Bands',
      value: totalBands,
      icon: 'Layers',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Active Bands',
      value: activeBands,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Draft Bands',
      value: draftBands,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Total Employees',
      value: totalEmployees,
      icon: 'Users',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Average Band Range',
      value: formatCurrency(averageSalary),
      icon: 'TrendingUp',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      label: 'Compliance Issues',
      value: complianceIssues,
      icon: 'AlertTriangle',
      color: complianceIssues > 0 ? 'text-destructive' : 'text-success',
      bgColor: complianceIssues > 0 ? 'bg-destructive/10' : 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-muted-foreground truncate">
                {stat?.label}
              </p>
              <p className="text-lg font-semibold text-foreground">
                {stat?.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BandStats;